<div *ngIf="isLoading; else powerbiTemplate" class="powerbi-spinner-container">
    <mat-spinner diameter=50 class="powerbi-spinner"></mat-spinner>
</div>
<ng-template #powerbiTemplate>
    <div style="display: flex;align-items: center;margin: 20px;">
        <label class="labelStyle">Group and Dataset:</label>
        <ng-select class="aip-select" appendTo="#selectOverlayDiv" 
                   [items]="allDatasets" 
                   [(ngModel)]="selectedDatasets"    
                   bindValue="id"                
                   bindLabel="label"
                   (ngModelChange)="onChange()">
        </ng-select> 
    </div>
    <div style="display: flex;align-items: center;margin: 20px;">
        <label class="labelStyle">DataSetID:</label><input class="bugStyle" type="text" [(ngModel)]="dataSetID" />
    </div>
    <div style="display: flex;align-items: center;margin: 20px;">
        <label class="labelStyle">Table:</label><input class="bugStyle" type="text" [(ngModel)]="tableName" />
    </div>
    <div style="margin: 20px;">
        <button mat-raised-button color="primary" (click)="getPowerBI()">Execute</button>
    </div>
    <div>
        <div><label class="labelStyle">10 records:</label></div>
        <div style="height: 420px;overflow: auto;">
        <pre id="PowerBIresult"></pre>
        </div>
    </div>
</ng-template>
<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>
